import React from 'react';
import { cx } from '../shared/ui/utils';

const buildRange = (page, pages) => {
  const delta = 2;
  const range = [];
  const start = Math.max(1, page - delta);
  const end = Math.min(pages, page + delta);
  for (let i = start; i <= end; i += 1) range.push(i);
  return range;
};

const Pagination = ({ page, pages, onChange }) => {
  if (!pages || pages <= 1) return null;
  const range = buildRange(page, pages);
  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="rounded-full border border-slate-200 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] disabled:opacity-40"
      >
        Prev
      </button>
      {range.map((num) => (
        <button
          key={num}
          type="button"
          onClick={() => onChange(num)}
          className={cx(
            'rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] border',
            num === page
              ? 'border-slate-900 bg-slate-900 text-white'
              : 'border-slate-200 text-slate-600'
          )}
        >
          {num}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= pages}
        onClick={() => onChange(page + 1)}
        className="rounded-full border border-slate-200 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] disabled:opacity-40"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
